// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../services/api-client.js';
import { PASSWORD_CHANGE_REQUIRED_ROUTE } from '../utils/password-change-required.js';

/**
 * Sprint 63.29.0 (#541) — takes a session the server holds for a password change
 * (403 `PASSWORD_CHANGE_REQUIRED` on any request) to the change-password step,
 * replacing the history entry so Back does not return to the refused page. The
 * shape of `MfaStepUpRedirector`. It renders nothing.
 */
export function PasswordChangeRedirector(): null {
  const navigate = useNavigate();
  useEffect(() => {
    apiClient.setOnPasswordChangeRequired(() => {
      navigate(PASSWORD_CHANGE_REQUIRED_ROUTE, { replace: true });
    });
    return () => apiClient.setOnPasswordChangeRequired(null);
  }, [navigate]);
  return null;
}
